import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { DocumentListResponse } from '@Types/api/form';
import { TypeDict } from '@Types/index';
import { getApiUrl } from '@Utils/getApiUrl';

const baseApiUrl = getApiUrl();

export const getDocument = (
  documentListResp: DocumentListResponse[],
  fileName: string
): DocumentListResponse | undefined => {
  const output = documentListResp.find(
    (document) => document.filename === fileName
  );

  return output;
};

export const getDocumentDownloadUrl = (documentId: string): string => {
  const lastBaseApiUrlChar = baseApiUrl[baseApiUrl.length - 1];
  const trailingSlash = lastBaseApiUrlChar === '/' ? '' : '/';

  return `${baseApiUrl}${trailingSlash}api/dms/v1/document/download?document_id=${documentId}`;
};

export const getFileTypeExt = (filepath: string): string => {
  const fileExt = filepath.split('.');
  return fileExt[fileExt.length - 1];
};

export const getDocTypeDescriptionFromDict = (
  dict: TypeDict[],
  code: number
): string => {
  return (
    dict.find((type) => type.codeNum === code)?.codeDesc ||
    EMPTY_FIELD_PLACEHOLDER
  );
};
